import { useEffect, useState } from 'react'

const useViewport = () => {
  const [width, setWidth] = useState(window.innerWidth)
  const [height, setHeight] = useState(window.innerHeight)

  useEffect(() => {
    const handleWindowResize = () => setWidth(window.innerWidth)
    window.addEventListener('resize', handleWindowResize)
    return () => window.removeEventListener('resize', handleWindowResize)
  }, [])

  useEffect(() => {
    const handleWindowResize = () => setHeight(window.innerHeight)
    window.addEventListener('resizeHeight', handleWindowResize)
    return () => window.removeEventListener('resizeHeight', handleWindowResize)
  }, [])

  return { width, height }
}

export default useViewport
